// @flow

import Service from './service';
import type { ApiConstructorArgsType } from '../types/api';
import type {
  CreateLoginArgs,
  EnterpriseConfigResponse,
  ProvisionArgs,
  ProvisionResponse,
} from '../types/enterprise/user';

export default class EnterpriseService extends Service {
  constructor(args: ApiConstructorArgsType = {}) {
    super(args);
    this.baseUrl = `${this.conf.path.serviceBase}/enterprise/v1`;
  }

  createAndProvision(payload: CreateLoginArgs): Promise<ProvisionResponse> {
    const agencyCode = window.location.host.split('.')[0] || 'www';
    const { source, code, id, email, password } = payload;

    const signupPayload = { email, password, source };
    const signupHeaders = {
      agencyCode,
      userType: 'consumer',
    };
    const redeemPayload = { source, code, id };

    return this.api.post(
      `${this.conf.path.authBase}/signup`,
      signupPayload,
      { headers: signupHeaders },
    )
      .then(() => this.api.post(`${this.baseUrl}/redeem`, redeemPayload))
      .then(res => res.data);
  }

  loginAndProvision(payload: CreateLoginArgs): Promise<ProvisionResponse> {
    const agencyCode = window.location.host.split('.')[0] || 'www';
    const { source, code, id, email, password } = payload;

    const loginPayload = { email, password, source };
    const loginHeaders = {
      agencyCode,
      userType: 'consumer',
    };
    const redeemPayload = { source, code, id };

    return this.api.post(
      `${this.conf.path.authBase}/login`,
      loginPayload,
      { headers: loginHeaders },
    )
      .then(() => this.api.post(`${this.baseUrl}/redeem`, redeemPayload))
      .then(res => res.data);
  }

  provision(payload: ProvisionArgs): Promise<ProvisionResponse> {
    return this.api.post(`${this.baseUrl}/redeem`, payload)
      .then(res => res.data);
  }

  fetchConfiguration(): Promise<EnterpriseConfigResponse> {
    return this.api.get(`${this.baseUrl}/config`)
      .then(res => res.data);
  }
}
